import { success } from "App/popupMessage";
import isEmpty from "lodash/isEmpty";
import locale from "./actionCreators.locale";
import actionTypes from "./actionTypes";
import api from "./api";
import { getUserStatusDictionary } from "./selectors";
export default {
    getUserStatusDictionary: () => (dispatch, getState) => isEmpty(getUserStatusDictionary(getState())) &&
        dispatch({
            type: actionTypes.GET_USER_STATUS_DICTIONARY,
            payload: {
                promise: () => api.getUserStatusDictionary()
            }
        }),
    getSelf: () => ({
        type: actionTypes.GET_SELF,
        payload: {
            promise: () => api.getSelf()
        },
        scope: actionTypes.GET_SELF
    }),
    getUsers: () => ({
        type: actionTypes.GET_USERS,
        payload: {
            promise: () => api.getUsers()
        }
    }),
    blockUsers: (ids) => ({
        type: actionTypes.BLOCK_USERS,
        payload: {
            promise: () => api.blockUsers(ids)
        },
        meta: { ids },
        completed: (dispatch) => {
            dispatch(success(ids.length > 1 ? locale.USERS_BLOCKED_SUCCESSFULLY : locale.USER_BLOCKED_SUCCESSFULLY));
        }
    }),
    unblockUsers: (ids) => ({
        type: actionTypes.UNBLOCK_USERS,
        payload: {
            promise: () => api.unblockUsers(ids)
        },
        meta: { ids },
        completed: (dispatch) => {
            dispatch(success(ids.length > 1 ? locale.USERS_UNBLOCKED_SUCCESSFULLY : locale.USER_UNBLOCKED_SUCCESSFULLY));
        }
    }),
    removeUsers: (ids) => ({
        type: actionTypes.REMOVE_USERS,
        payload: {
            promise: () => api.removeUsers(ids)
        },
        meta: { ids },
        completed: (dispatch) => {
            dispatch(success(ids.length > 1 ? locale.USERS_REMOVED_SUCCESSFULLY : locale.USER_REMOVED_SUCCESSFULLY));
        }
    }),
    saveUser: (data) => ({
        type: actionTypes.SAVE_USER,
        payload: {
            promise: () => api.saveUser(data)
        },
        scope: `${actionTypes.SAVE_USER}_${data.Id}`,
        completed: (disp) => {
            disp(success(locale.USER_SAVED_SUCCESSFULLY));
        }
    })
};
